import type { FindBoardPlacement } from "./types";

export function summarizeBoardPlacements(placements: FindBoardPlacement[]): string | null {
  if (placements.length === 0) {
    return null;
  }

  if (placements.length === 1) {
    return `in ${placements[0]!.boardLabel}`;
  }

  return `in ${placements[0]!.boardLabel} +${placements.length - 1} more`;
}
